<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>James was born in London in 1936 where he experienced the outbreak of the Second World War. In 1941, he was taken to Canada and educated there and in the US. Upon graduation he worked as a map surveyor in the Canadian arctic. The land was surveyed for map making during the winter months as it was easier to traverse and measure the distance. James learned the ways of the north by living with the Cree Indians. He walked on snowshoes and many days covered over 50 miles in -70°F weather. He camped out in a tent, cooked over a wood fire, which he started without matches, a skill he learnt from the Cree and boiled snow for water. After his northern adventures and further worldwide travelling, he established a chain of retail stores selling sheepskins and homemade goods. A few decades later, he returned to the UK and settled on a farm.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7213cdd4